import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {VanillaReaderUI} from "./VanillaReaderUI";

export interface VanillaReaderUiButtonMenuController extends IVanillaReaderUiComponentController, IVanillaReaderUI {}

/**
 * # VanillaReaderUiButtonMenuController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiButtonMenu` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 * - VanillaReaderUiButtonMenu
 *
 * */
export class VanillaReaderUiButtonMenuController {
    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.buttonMenu.onMenuClick(vanillaReaderUiContext._onButtonMenuClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.buttonMenu.onSideMenuClick(vanillaReaderUiContext._onButtonSideMenuClicked.bind(vanillaReaderUiContext));
    }

    _onInitialise(): void {

    }
    
    _onButtonMenuClicked(): void {
        this.menuBottom.show();
    };

    _onButtonSideMenuClicked(): void {
        this.menuSide.show();
    };

}
